import React from 'react';
import CheckIcon from '@mui/icons-material/Check';
import ClearIcon from '@mui/icons-material/Clear';
import { isPasswordValid } from 'src/common/validators';

const passwordRegexMap = {
  eightChars: new RegExp(/^.{8,}$/),
  lowerChar: new RegExp(/.*[a-z].*/),
  upperChar: new RegExp(/.*[A-Z].*/),
  numericalChar: new RegExp(/.*\d.*/),
  specialChar: new RegExp(/.*\W.*/),
};

const strengthIcon = (pass: boolean) => {
  return pass ? <CheckIcon color="primary" /> : <ClearIcon color="error" />;
};

export const PasswordStrength = ({ password, email }) => {
  const eightChars = passwordRegexMap.eightChars.test(password);
  const lowerChar = passwordRegexMap.lowerChar.test(password);
  const upperChar = passwordRegexMap.upperChar.test(password);
  const numericalChar = passwordRegexMap.numericalChar.test(password);
  const specialChar = passwordRegexMap.specialChar.test(password);
  const noBannedWords = email.includes('kixie.com');

  const { valid: passwordIsValid, word } = isPasswordValid(password);

  return (
    <div>
      <div style={{ display: 'flex' }}>
        {strengthIcon(eightChars)}
        <p style={{ marginBottom: '0px', marginLeft: '5px' }}>
          Must be at least 8 characters
        </p>
      </div>
      <div style={{ display: 'flex' }}>
        {strengthIcon(lowerChar)}
        <p style={{ marginBottom: '0px', marginLeft: '5px' }}>
          Must have at least 1 lowercase character
        </p>
      </div>
      <div style={{ display: 'flex' }}>
        {strengthIcon(upperChar)}
        <p style={{ marginBottom: '0px', marginLeft: '5px' }}>
          Must have at least 1 uppercase character
        </p>
      </div>
      <div style={{ display: 'flex' }}>
        {strengthIcon(numericalChar)}
        <p style={{ marginBottom: '0px', marginLeft: '5px' }}>
          Must have at least 1 numerical character
        </p>
      </div>
      <div style={{ display: 'flex' }}>
        {strengthIcon(specialChar)}
        <p style={{ marginBottom: '0px', marginLeft: '5px' }}>
          Must have at least 1 special character
        </p>
      </div>
      {noBannedWords ? (
        <div style={{ display: 'flex' }}>
          {strengthIcon(passwordIsValid)}
          <p style={{ marginBottom: '0px', marginLeft: '5px' }}>
            {passwordIsValid ? (
              'Does not contain a banned word'
            ) : (
              <>
                Must not contain a banned word.{' '}
                <em>
                  <b>{word}</b>
                </em>{' '}
                is not valid.
              </>
            )}
          </p>
        </div>
      ) : null}
    </div>
  );
};
